function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment } from 'react';
import { Dropdown, Input } from '@nackle/paper';
import CompanyService from '../../services/company';
import SolutionService from '../../services/solution';
import { brandingURL } from '../../endpoints';
import './company-select.less';

var CompanySelect = /*#__PURE__*/function (_React$Component) {
  _inherits(CompanySelect, _React$Component);

  var _super = _createSuper(CompanySelect);

  function CompanySelect() {
    var _this;

    _classCallCheck(this, CompanySelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      companies: [],
      recentCompanies: [],
      selectedCompany: null,
      selectedCompanyLoaded: false,
      solution: null,
      branding: null,
      dropdownVisible: false,
      companyStyles: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleDropDownVisibleChange", function (visible) {
      _this.setState({
        dropdownVisible: visible
      }, function () {
        if (visible) {
          setTimeout(function () {
            document.getElementById('companySelectInput').focus();
          }, 333);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCompanyChange", function (company) {
      var onChange = _this.props.onChange;

      if (typeof onChange === 'function') {
        onChange(company);
      }

      _this.setState({
        filter: '',
        dropdownVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadCompanies", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var auth, companyService, companies, recentCompanies;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              auth = _this.props.auth;
              _context.prev = 1;
              companyService = new CompanyService(auth.state);
              _context.next = 5;
              return companyService.listCompanies();

            case 5:
              companies = _context.sent;
              recentCompanies = getRecentCompanies(companies);

              _this.setState({
                companies: companies,
                recentCompanies: recentCompanies
              });

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

              _this.setState({
                companies: [],
                recentCompanies: []
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadSolutionAndBranding", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var auth, solutionService, solution;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              auth = _this.props.auth;
              _context2.prev = 1;
              solutionService = new SolutionService(auth.state);
              _context2.next = 5;
              return solutionService.getSolution();

            case 5:
              solution = _context2.sent;

              _this.setState({
                selectedCompanyLoaded: true,
                solution: solution
              });

              _context2.next = 13;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);

              _this.setState({
                selectedCompanyLoaded: true
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    })));

    return _this;
  }

  _createClass(CompanySelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadCompanies();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
          selectedCompany = _this$state.selectedCompany,
          selectedCompanyLoaded = _this$state.selectedCompanyLoaded;

      if (selectedCompany && !selectedCompanyLoaded) {
        this.loadSolutionAndBranding();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          companies = _this$state2.companies,
          recentCompanies = _this$state2.recentCompanies,
          selectedCompany = _this$state2.selectedCompany,
          solution = _this$state2.solution,
          dropdownVisible = _this$state2.dropdownVisible;
      return /*#__PURE__*/React.createElement(Dropdown, {
        visible: dropdownVisible,
        onVisibleChange: this.handleDropDownVisibleChange,
        overlay: /*#__PURE__*/React.createElement(CompanySelectMenu, {
          companies: companies,
          recentCompanies: recentCompanies,
          onChange: this.handleCompanyChange
        }),
        trigger: ['click']
      }, /*#__PURE__*/React.createElement("div", {
        className: "company-select",
        onClick: this.handleSelectClick
      }, selectedCompany ? /*#__PURE__*/React.createElement(Fragment, null, selectedCompany ? /*#__PURE__*/React.createElement("img", {
        className: "company-select-logo",
        src: "".concat(brandingURL, "/companies/").concat(selectedCompany.id, "/logos/primary")
      }) : /*#__PURE__*/React.createElement("span", {
        className: "company-select-logo-placeholder"
      }), /*#__PURE__*/React.createElement("div", {
        className: "company-select-name-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "company-select-name"
      }, selectedCompany.name), /*#__PURE__*/React.createElement("span", {
        className: "company-select-solution"
      }, solution ? solution.name : '', "\xA0"))) : /*#__PURE__*/React.createElement("span", {
        className: "placeholder"
      }, "select a company..."), /*#__PURE__*/React.createElement(DownIcon, {
        className: "down"
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var _state$selectedCompan;

      if (props.companyId === ((_state$selectedCompan = state.selectedCompany) === null || _state$selectedCompan === void 0 ? void 0 : _state$selectedCompan.id)) {
        return null;
      }

      if (!props.companyId && !state.selectedCompany) {
        return null;
      }

      if (!props.companyId && state.selectedCompany) {
        return {
          selectedCompany: null
        };
      }

      var selectedCompany = state.companies.find(function (c) {
        return c.id === props.companyId;
      });

      if (selectedCompany) {
        saveToRecentCompanies(selectedCompany);
        return {
          selectedCompany: selectedCompany,
          selectedCompanyLoaded: false,
          solution: null,
          branding: false,
          recentCompanies: getRecentCompanies(state.companies)
        };
      }

      return {
        selectedCompany: null
      };
    }
  }]);

  return CompanySelect;
}(React.Component);

export { CompanySelect as default };

function saveToRecentCompanies(company) {
  if (!localStorage) {
    return;
  }

  var recentCompanies = localStorage.getItem('recent-companies');

  if (recentCompanies) {
    recentCompanies = JSON.parse(recentCompanies);
  } else {
    recentCompanies = [];
  } // remove the current company, and limit it to the last 4


  recentCompanies = recentCompanies.filter(function (companyId) {
    return companyId !== company.id;
  }).filter(function (companyId, index) {
    return index < 4;
  });
  localStorage.setItem('recent-companies', JSON.stringify([company.id].concat(_toConsumableArray(recentCompanies))));
}

function getRecentCompanies(allCompanies) {
  if (!localStorage) {
    return [];
  }

  var recentCompanies = localStorage.getItem('recent-companies');

  if (recentCompanies) {
    recentCompanies = JSON.parse(recentCompanies);
  } else {
    recentCompanies = [];
  }

  return recentCompanies.map(function (companyId) {
    return allCompanies.find(function (company) {
      return companyId === company.id;
    });
  }).filter(function (company) {
    return !!company;
  });
}

var DownIcon = function DownIcon(_ref3) {
  var props = _extends({}, _ref3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.544 6.044l-9.544 9.541-9.544-9.541-1.416 1.416 10.25 10.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l10.25-10.25-1.409-1.416z"
  }));
};

var CompanySelectMenu = /*#__PURE__*/function (_React$Component2) {
  _inherits(CompanySelectMenu, _React$Component2);

  var _super2 = _createSuper(CompanySelectMenu);

  function CompanySelectMenu() {
    var _this2;

    _classCallCheck(this, CompanySelectMenu);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      filter: '',
      filteredCompanies: []
    });

    _defineProperty(_assertThisInitialized(_this2), "handleFilterChange", function (e) {
      var companies = _this2.props.companies;
      var filter = e.target.value;

      _this2.setState({
        filter: filter,
        filteredCompanies: filter ? companies.filter(function (company) {
          return company.name.toLowerCase().includes(filter.toLowerCase());
        }) : []
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "handleFilterKeyUp", function (e) {
      var _this2$state = _this2.state,
          filter = _this2$state.filter,
          filteredCompanies = _this2$state.filteredCompanies;

      if (e.keyCode === 13) {
        if (filter && filteredCompanies.length == 1) {
          _this2.handleCompanyClick(filteredCompanies[0])(e);
        }
      } else if (e.keyCode === 27) {
        _this2.handleSelectClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "handleCompanyClick", function (company) {
      return function () {
        var onChange = _this2.props.onChange;

        if (typeof onChange === 'function') {
          onChange(company);
        }

        _this2.setState({
          filter: ''
        });
      };
    });

    return _this2;
  }

  _createClass(CompanySelectMenu, [{
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          filter = _this$state3.filter,
          filteredCompanies = _this$state3.filteredCompanies;
      var _this$props = this.props,
          companies = _this$props.companies,
          recentCompanies = _this$props.recentCompanies;
      return /*#__PURE__*/React.createElement("div", {
        className: "company-select-menu"
      }, /*#__PURE__*/React.createElement(Input, {
        autoFocus: true,
        id: "companySelectInput",
        className: "company-select-filter",
        placeholder: "search companies...",
        value: filter,
        onKeyUp: this.handleFilterKeyUp,
        onChange: this.handleFilterChange,
        size: "large",
        autoComplete: "off",
        allowClear: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "company-select-list-container"
      }, filter ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
        className: "company-select-header"
      }, "Search Results"), this.renderCompanyList(filteredCompanies)) : /*#__PURE__*/React.createElement(Fragment, null, recentCompanies.length > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h2", {
        className: "company-select-header"
      }, "Recent Companies"), this.renderCompanyList(recentCompanies)), /*#__PURE__*/React.createElement("h2", {
        className: "company-select-header"
      }, "All Companies"), this.renderCompanyList(companies))));
    }
  }, {
    key: "renderCompanyList",
    value: function renderCompanyList(companies) {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("ul", {
        className: "company-select-list"
      }, companies.map(function (company) {
        return /*#__PURE__*/React.createElement("li", {
          key: company.id,
          className: "company-select-list-item",
          onClick: _this3.handleCompanyClick(company)
        }, /*#__PURE__*/React.createElement("img", {
          className: "company-select-list-item-colors",
          src: "".concat(brandingURL, "/companies/").concat(company.id, "/logos/colors")
        }), /*#__PURE__*/React.createElement("span", {
          className: "company-name"
        }, company.name), /*#__PURE__*/React.createElement("div", {
          className: "company-select-list-item-logo-container"
        }, /*#__PURE__*/React.createElement("img", {
          className: "company-select-list-item-logo",
          src: "".concat(brandingURL, "/companies/").concat(company.id, "/logos/primary")
        })));
      }));
    }
  }]);

  return CompanySelectMenu;
}(React.Component);
//# sourceMappingURL=company-select.js.map